import React from "react";
import classes from "./Section2.module.css";
import photo from "../../assests/img/john-doe.webp";
import imp from "../../assests/img/react-beta.png";
import Pagination from "@mui/material/Pagination";
import { Link } from "react-router-dom";

const Section2 = ({ darkSide, toggleDarkMode }) => {
  return (
    <div
      className={
        darkSide === true ? classes["section2-dark"] : classes["section2"]
      }
    >
      <div className={classes["section2-container"]}>
        <div className={classes["section2-nav"]}>
          <div className={classes["section2-nav-container"]}>
            <div
              className={`${classes["section2-nav-item"]} ${classes["active"]}`}
            >
              All
            </div>
            <div className={classes["section2-nav-item"]}>Sports</div>
            <div className={classes["section2-nav-item"]}>Story</div>
            <div className={classes["section2-nav-item"]}>Story</div>
            <div className={classes["section2-nav-item"]}>Story</div>
          </div>
        </div>
        <div className={classes["section2-box"]}>
          <div className={classes["s2-box-flex"]}>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <Link to="/detail">
                    <h3>How To Create a Responsive Top Navigation Menu</h3>
                  </Link>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <Link to="/detail">
                    <h3>How To Create a Responsive Top Navigation Menu</h3>
                  </Link>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <Link to="/detail">
                    <h3>How To Create a Responsive Top Navigation Menu</h3>
                  </Link>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <Link to="/detail">
                    <h3>How To Create a Responsive Top Navigation Menu</h3>
                  </Link>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <Link to="/detail">
                    <h3>How To Create a Responsive Top Navigation Menu</h3>
                  </Link>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes["main"]}>
              <div className={classes["main-box"]}>
                <img className={classes["main-box-img"]} src={imp} alt="" />
                <div className={classes["s2-name"]}>
                  <div className={classes["s2-name-container"]}>React</div>
                </div>
                <div className={classes["s2-content"]}>
                  <Link to="/detail">
                    <h3>How To Create a Responsive Top Navigation Menu</h3>
                  </Link>
                  <div
                    style={{ marginTop: 27 }}
                    class="flex items-center space-x-4"
                  >
                    <img
                      style={{
                        background: "#E2E8F0",
                        width: "50px",
                        marginRight: 15,
                      }}
                      class="w-10 h-10 rounded-full"
                      src={photo}
                      alt=""
                    />
                    <div class="font-medium dark:text-white">
                      <div style={{ color: "#2d3849" }}>Jese Leos</div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2d3849",
                        }}
                      >
                        <div
                          style={{ color: "#2d3849" }}
                          class="text-sm text-gray-500 dark:text-gray-400"
                        >
                          May 26,2020
                        </div>
                        <svg
                          style={{ marginRight: 10, marginLeft: 10 }}
                          stroke="currentColor"
                          fill="#2d3849"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          class="css-uk6cul"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
                        </svg>
                        2min
                      </div>
                    </div>
                  </div>
                  <div className={classes["eye-main"]}>
                    <div className={classes["eye-container"]}>
                      <svg
                        style={{ width: "20px", fill: "#718096" }}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                      </svg>
                      <p>1000</p>
                    </div>
                    <svg
                      style={{
                        width: "20px",
                        fill: "#718096",
                        marginLeft: "25px",
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path d="M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            sx={{ display: "flex", justifyContent: "center", marginTop: 3 }}
            count={10}
            shape="rounded"
          />
          {/* <nav aria-label="Page navigation example">
            <ul class="inline-flex items-center -space-x-px">
              <li>
                <a
                  href="#"
                  class="block py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  <span class="sr-only">Previous</span>
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </a>
              </li>
              <li className={classes["s2-li"]}>
                <a
                  href="#"
                  class="py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  1
                </a>
              </li>
              <li className={classes["s2-li"]}>
                <a
                  href="#"
                  class="py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  2
                </a>
              </li>
              <li className={classes["s2-li"]}>
                <a
                  href="#"
                  aria-current="page"
                  class="z-10 py-2 px-3 leading-tight text-blue-600 bg-blue-50 border border-blue-300 hover:bg-blue-100 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white"
                >
                  3
                </a>
              </li>
              <li className={classes["s2-li"]}>
                <a
                  href="#"
                  class="py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  4
                </a>
              </li>
              <li className={classes["s2-li"]}>
                <a
                  href="#"
                  class="py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  5
                </a>
              </li>
              <li>
                <a
                  href="#"
                  class="block py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                >
                  <span class="sr-only">Next</span>
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </a>
              </li>
            </ul>
          </nav> */}
        </div>
      </div>
    </div>
  );
};

export default Section2;
